import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";

import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from "../../../signal/allUsersSignal";
import AddFarmerModal from "./AddFarmerModal";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import Select from "react-select";

export default function FarmersList() {


    const [searchParams, setSearchParams] = useSearchParams();
    const [Farmers, setFarmers] = useState([]);
    const [FarmersToDisplay, setFarmersToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    const [showAddFarmerModal, setShowAddFarmerModal] = useState(false);
    const [selectedFarmer, setSelectedFarmer] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(35);
    const [totalItems, setTotalItems] = useState(0);
    const [userId, setUserId] = useState(searchParams.get("userId") ? searchParams.get("userId") : "");
    const [city, setCity] = useState(searchParams.get("city") ? searchParams.get("city") : "");
    const [cities, setCities] = useState([]);

    const navigate = useNavigate();

    // useEffect(() => {
    //     setFarmersToDisplay(Farmers.filter((item) => {
    //         if (search === "") return true;
    //         if (item?.name?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.gstin?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.phoneNumber?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.address?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.city?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.state?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.pincode?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.email?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.website?.toLowerCase().includes(search.toLowerCase())) return true;
    //         let user = allUsersSignal.value[item.userId];
    //         if (user) {
    //             if (user.name.toLowerCase().includes(search.toLowerCase())) return true;
    //         }
    //         if (moment(item.createdAt).format("DD/MM/YY hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;

    //         return false;
    //     }))
    // }, [search, Farmers])

    const getFarmers = useQuery(["Farmers", page, perPage, search, userId, city], async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/farmer/v2/dashboard?page=${page}&perPage=${perPage}&search=${search}&userId=${userId}&city=${city}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setFarmers(data.data?.farmers || []);
                setPage(data.data?.page || 1);
                setPerPage(data.data?.perPage || 35);
                setTotalItems(data.data?.totalItems || 0);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const refetchFarmers = () => {
        getFarmers.refetch({ cancelRefetch: true });

    }

    const getCitiesQuery = useQuery("farmerCities", async () => {
        let resp = await axios.get(`${DEV_SERVER}/farmer/v2/cities`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setCities(data.data || []);
            } else {
                toast.error(data.message);
            }
        },
        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Unable to fetch cities");
            }
        }
    });

    const delaerDeleteMutation = useMutation((body) => axios.delete(`${DEV_SERVER}/farmer/v2/${body.id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success("Farmer deleted successfully")
                refetchFarmers()
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleFarmerDelete = (id) => {

        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this Farmer?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        delaerDeleteMutation.mutate({ id: id })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ],
            overlayClassName: "overlay-custom-confirm-alert",
        });


    }

    useEffect(() => {
        refetchFarmers();
        getCitiesQuery.refetch({ cancelRefetch: true });

    }, [page, perPage, search])

    const handleFilters = async () => {

        const tempSearchParam = new URLSearchParams({ userId: userId, city: city })
        setSearchParams(tempSearchParam);

        await refetchFarmers();
    }

    const columns = [
        {
            name: "Name",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={
                    <Tooltip style={{ position: "fixed" }}>
                        {row?.name}
                    </Tooltip>
                }>
                    <span>{row?.name}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Phone Number",
            color: true,
            center: true,
            selector: "phoneNumber",
        },
        {
            name: "GSTIN",
            color: true,
            center: true,
            selector: "gstin",
            sortable: true,
        },
        {
            name: "Address",
            color: true,
            center: true,
            width: "200px",
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={
                    <Tooltip style={{ position: "fixed" }}>
                        {`${row?.address}, ${row?.city}, ${row?.state}, ${row?.pincode}`}
                    </Tooltip>
                }>
                    <span>{`${row?.address !== "" ? row?.address + ", " : ""} ${row?.city !== "" ? row?.city + ", " : ""} ${row?.state !== "" ? row?.state + ", " : ""} ${row?.pincode !== "" && row?.pincode !== 0 ? row?.pincode : ""}`}</span>
                </OverlayTrigger>
            },
            sortable: true,
        },{
            name: "Group",
            selector: 'group',
            center: true
        },
        {
            name: "Website",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.website && row?.website !== "") {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.website}</Tooltip>}>
                        <a href={row?.website} target="_blank" rel="noopener noreferrer" style={{ color: "#0d6efd", textDecoration: "none" }}>
                            {row?.website.length > 30 ? row?.website.substring(0, 30) + "..." : row?.website}
                        </a>
                    </OverlayTrigger>
                }
                return "NA"
            },
            width: "200px"
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap", }}>
                {(row?.visitingCard?.length && row?.visitingCard?.length > 0) && row?.visitingCard?.map((m) =>
                    <>
                        <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px", pointerEvents: "none" }} /></Zoom>
                    </>
                )}
            </div>
        },
        {
            name: "Added by",
            color: true,
            selector: (row) => {
                let user = allUsersSignal.value[row?.userId];
                if (user) {
                    return <span style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                        <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={user.profileURL !== "" ? user.profileURL : avatar1} />
                        {user.name}
                    </span>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Updated At",
            color: true,
            center: true,
            sortable: true,
            selector: "updatedAt",
            cell: (row) => {
                return moment(row?.updatedAt).format("DD/MM/YY hh:mm A")
            }
        },
        {
            name: "Location",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.location?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.location[0]},${row?.location[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Action",
            center: true,
            selector: (row) => {
                return <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            setSelectedFarmer(row);
                            setShowAddFarmerModal(true);
                        }}><i className="far fa-edit table-icons"></i></span>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            handleFarmerDelete(row?.id)
                        }}><i className="far fa-trash-alt table-icons"></i></span>
                    </OverlayTrigger>
                </div>
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Farmers List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>

                                <Accordion className="mb-3">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                
                                                <div>
                                                    <label htmlFor="maxAmount">User</label>
                                                    <Select
                                                        options={Object.keys(allUsersSignal?.value).map((key) => {
                                                            return { value: allUsersSignal?.value[key].id, label: allUsersSignal?.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setUserId(e.value);
                                                            } else {
                                                                setUserId("");
                                                            }
                                                        }}

                                                        value={allUsersSignal?.value[userId] ? { value: allUsersSignal?.value[userId].id, label: allUsersSignal?.value[userId].name } : null}

                                                        isClearable
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="city">City</label>
                                                    <Select
                                                        options={cities.map((cityName) => {
                                                            return { value: cityName, label: cityName }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setCity(e.value);
                                                            } else {
                                                                setCity("");
                                                            }
                                                        }}
                                                        value={city ? { value: city, label: city } : null}
                                                        isClearable
                                                        placeholder="Select city"
                                                    />
                                                </div>



                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setUserId("");
                                                    setCity("");
                                                    const tempSearchParam = new URLSearchParams({ userId: "", city: "" });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>

                                <div style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem", justifyContent: "space-between" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                    <div>
                                        <button onClick={() => setShowAddFarmerModal(true)} className="btn btn-primary">
                                            <i className="fas fa-plus"></i>
                                            <span className="ms-1">Add Farmer</span>
                                        </button>
                                    </div>
                                </div>
                                {(!getFarmers.isLoading && !getFarmers?.isFetching) &&
                                    <DataTable
                                        columns={columns} data={Farmers} pagination={true}
                                        onRowClicked={(row) => navigate(`/dashboard/Farmers/${row?.id}`)}
                                        paginationServer={true} paginationTotalRows={totalItems} paginationPerPage={perPage} paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                        paginationDefaultPage={page}
                                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                            setPerPage(currentRowsPerPage);
                                        }
                                        } onChangePage={(currentPage) => {
                                            setPage(currentPage);
                                        }}
                                        customStyles={
                                            {
                                                cells: "center",
                                                rows: {
                                                    style: {
                                                        cursor: "pointer",
                                                        backgroundColor: "unset"
                                                    }
                                                }
                                            }
                                        }
                                    />}
                                {(getFarmers.isLoading || getFarmers?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showAddFarmerModal && <AddFarmerModal Farmer={selectedFarmer} close={() => {
                setShowAddFarmerModal(false)
                setSelectedFarmer(null)
            }} show={showAddFarmerModal} refetchFarmers={refetchFarmers} />}
        </>
    )
}
